module.exports = __webpack_public_path__ + "img/carlnielsen.9fe78c84.jpg";